import React from "react";
import { Card, CardContent, Typography, Box } from "@mui/material";

const WideCard = ({ title, metrics }) => (
  <Card>
    <CardContent>
      <Typography variant="h6" gutterBottom>
        {title}
      </Typography>
      <Box display="flex" justifyContent="space-evenly" mt={2}>
        {metrics.map((metric, index) => (
          <Box key={index} textAlign="center">
            <Typography variant="subtitle2" color="text.secondary">
              {metric.label}
            </Typography>
            <Typography variant="h4" color={metric.color}>
              {metric.value}
            </Typography>
          </Box>
        ))}
      </Box>
    </CardContent>
  </Card>
);

export default WideCard;
